import { render, staticRenderFns } from "./InputField.vue?vue&type=template&id=74b9eb41&"
import script from "./InputField.vue?vue&type=script&lang=js&"
export * from "./InputField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b9eb41')) {
      api.createRecord('74b9eb41', component.options)
    } else {
      api.reload('74b9eb41', component.options)
    }
    module.hot.accept("./InputField.vue?vue&type=template&id=74b9eb41&", function () {
      api.rerender('74b9eb41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/custom-fields/InputField.vue"
export default component.exports